import React, {useState, useEffect} from 'react'
import './Row.css'
import axios from '../axios'

const Row = ({ title, fetchUrl, isLargeRow = false }) => {

    const [movies, setMovies] = useState([])
    const baseUrl = 'https://image.tmdb.org/t/p/original/'
    useEffect(() => {
        async function fetchData(){
            const request = await axios.get(fetchUrl)
            setMovies(request.data.results)
            return request
        }

        fetchData()
    }, [fetchUrl])

    console.log(movies)
    return (
        <div className='row'>
            <h2 
                style={{marginTop: 5}}
            >   
                {title}
            </h2>

            <div className='row_data'>
                {movies.map(movie => (
                    <img
                        className={`row_poster ${isLargeRow && 'row_posterLarge'}`}
                        key={movie.id} 
                        src={`${baseUrl}${
                            isLargeRow? movie.poster_path : movie.backdrop_path
                        }`} 
                        alt={movie.name} />
                ))}
            </div>
        </div>
    )
}

export default Row
